import React, { useContext, useState } from "react";

import NextButtonVector from "../../resources/nextButtonVector";
import { SVTUserContext } from "../../utils/SVTUserContext";
import { useTranslation, Trans } from "react-i18next";

const Guidelines = ({ onNext }) => {
    const { activeTab, setIsGuidelinesModalOpen } = useContext(SVTUserContext); // Access the state setter
    const [isVisible, setIsVisible] = useState(true); // State to control popup visibility

    const handleClose = () => {
        setIsVisible(false); // Close the popup
        setIsGuidelinesModalOpen(false); // Reset the state in the parent component
    };
    const { t } = useTranslation();

    if (!isVisible) {
        return null; // Do not render the popup if it's not visible
    }

    return (
        <div className="guidelines-modal col-sm-9">
            <div className="guidelines-modal-content">
                {/* <span className="close" onClick={handleClose}>
                    &times;
                </span> */}
                {activeTab === "Tab1" && (
                    <>
                        <span className="close" onClick={handleClose}>
                            &times;
                        </span>
                    </>
                )}
                <div className="guidelines">
                    <div className="">
                        <h2>{t("assessmentGuidelines")}</h2>
                        <div>
                            <h4>{t("step1")}</h4>
                            {t("step1Description")}
                        </div>
                        <div>
                            <h4>{t("step2")}</h4>
                            {t("step2Description")}
                            <span style={{ fontWeight: "bold" }}>
                                {t("note")}
                                </span>
                           {t("step2Requirement")}
                        </div>
                        <div>
                            <h4>{t("step3")}</h4>
                            {t("step3Description")}
                        </div>
                        <div>
                            <h4>{t("step4")}</h4>
                            {t("step4Description")}
                        </div>
                        <div>
                            <h4>{t("step5")}</h4>
                            {t("step5Description")}
                        </div>
                        <div>
                            <h2>{t("additionalFeatures")}</h2>
                            <b>{t("resourcePopupHitachiGuidance")}</b> 
                            {/* {t("resourcePopupDescription")} */}
                            <Trans i18nKey="resourcePopupDescription"></Trans>
                            {/* <b>{t("hitachiGuidance")}</b> {t("hitachiGuidanceDescription")} */}
                        </div>
                        <div style={{padding: "10px 0px"}}>
                            <b>{t("aggregateScore")}</b> {t("aggregateScoreDescription")}
                        </div>
                        <div>
                            <b>{t("evidenceAndComments")}</b> {t("evidenceAndCommentsDescription1")}<span style={{ color: "#c80000" }}>
  {t("evidenceAndCommentsDescription2")}
</span>

                        </div>
                        <button className="guidelines-button" onClick={onNext}>
                            {activeTab === "Tab1" ? (
                                <>
                                    {t("next")} <NextButtonVector />
                                </>
                            ) : (
                                t("close")
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Guidelines;
